const ShowIf = (props: { children: any; condition: boolean }) => {
  const { children, condition = false } = props;
  if (condition && children && children.length !== undefined) {
    return <>{children}</>;
  }
  if (condition) {
    return children;
  }
  return null;
};

export default ShowIf;
